<mat-card class="slidecontent dd-drawer">

  <div class="dd-head">
    <div class="dd-head__who">
      <div class="dd-avatar">
        <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http'; else showName">
          <img src="{{ ImagePathURL }}" alt="" />
        </ng-container>
        <ng-template #showName>
          <span class="dd-avatar__initials">{{ getShortName(transactionUserName) }}</span>
        </ng-template>
        <label class="dd-avatar__upload" matTooltip="Change photo" matTooltipClass="tooltip">
          <input type="file" (change)="onSelectFile($event)" />
          <mat-icon>camera_alt</mat-icon>
        </label>
      </div>
      <div class="dd-head__text">
        <span class="dd-kicker">{{ (modulenames || 'Record') }} details</span>
        <h3 (click)="openInDocument()">{{ transactionUserName }}</h3>
        <p *ngIf="transactionUserRole">{{ transactionUserRole }}</p>
      </div>
    </div>

    <div class="dd-head__actions">
      <button mat-icon-button class="dd-pcc" *ngIf="modulenames == 'Core'"
        [class.is-synced]="pendingPatientId" [disabled]="!showPCC"
        matTooltip="{{showPaycheck==true ? 'Sync With Paychex' : pccToolTip}}" matTooltipClass="tooltip"
        (click)="SendtoPendingPatientPCC()">
        <img *ngIf="pendingPatientId" src="../../../../assets/icons/pccfavicon-32x32.png" alt="" />
        <img *ngIf="!pendingPatientId" src="../../../../assets/icons/pccfavicon-gray.png" alt="" />
      </button>
      <button mat-icon-button *ngIf="showPaycheck==true" matTooltip="Paychex" matTooltipClass="tooltip">
        <mat-icon>local_parking</mat-icon>
      </button>
      <button mat-icon-button (click)="openDocumentInNewTab()" matTooltip="Open in new tab" matTooltipClass="tooltip">
        <mat-icon>open_in_new</mat-icon>
      </button>
      <button mat-icon-button class="dd-close" (click)="closeListingDetails()" matTooltip="Close" matTooltipClass="tooltip">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dd-note" *ngIf="selectedTabIndex == 0">
    <span class="dd-note__dot"></span>
    Changes are saved only when you select <strong>Save changes</strong>.
  </div>

  <div class="dialog_content">
   <mat-tab-group mat-stretch-tabs="true" #tabs animationDuration="0ms" (selectedTabChange)="onTabClick($event)"
   [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="Detail">
     <div class="userdetails compdetail">
    <form [formGroup]="myFormGroup">
      <ng-container *ngFor="let field of coreUserList">
        <div *ngIf="field.fieldID==0 && field.data.length>0" class="fullw groupHolder" [ngSwitch]="field.fieldTypeName">
          <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
            <mat-expansion-panel-header>
              <mat-panel-title>
              {{field.data[0].groupName}}   
            </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let grpField of field.data"> 
            
              <div *ngIf="grpField.fieldID>0" class="fullw" [ngSwitch]="grpField.fieldTypeName"
                [class.fullw--wide]="isWideField(grpField)">
                <ng-container *ngSwitchCase="'Textbox'">
                  <ng-container *ngIf="grpField.fieldName == 'Name'">
                          <mat-form-field>
                            <input
                              matInput
                              [required]="grpField.isRequired"
                              placeholder="{{ grpField.fieldName }}"
                              [(ngModel)]="transactionUserName"
                              formControlName="{{ grpField.fieldName }}"
                              [readonly] = "grpField.rolePermission==1"
                            />                           
    
                          
                          </mat-form-field>
                  </ng-container>
    
                  <ng-container *ngIf="grpField.fieldName != 'Name'">
                    <ng-container *ngIf="grpField.fieldNames.length > 0">
                      <div class="multipleBlock">
                        <div class="multype">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select
                              (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{ grpField.fieldName + 'option' }}"
                              placeholder="{{ grpField.placeholderVal }}"
                            >
                              <mat-option
                                value="{{ names.fieldNameID }}"
                                *ngFor="let names of grpField.fieldNames"
                              >
                                {{ names.fieldName }}</mat-option
                              >
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field>
                            <input [required]="grpField.isRequired"
                            *ngIf="grpField.fieldName == 'Phone'"
                           matInput
                            placeholder="Add Phone"
                            [(ngModel)]="grpField.fieldValue"
                            formControlName="{{ grpField.fieldName }}"
                           
                            [readonly] = "grpField.rolePermission==1"
                          />
                          <input [required]="grpField.isRequired"
                            *ngIf="grpField.fieldName != 'Phone'"
                            matInput
                            placeholder="Add {{ grpField.placeholder }}"
                            [(ngModel)]="grpField.fieldValue"
                            formControlName="{{ grpField.fieldName }}"
                            [readonly] = "grpField.rolePermission==1"
                          />
                          </mat-form-field>
                          
                          <div class="inOline" *ngIf="grpField.fieldName == 'Address'">

                            <div class="divide">
                              <mat-form-field>
                                <input type="text"
                                placeholder="City"
                                [(ngModel)]="cityValue"
                                aria-label="Number"
                                matInput
                                (input)="searchCity($event.target.value)"
                                formControlName="City"
                                [matAutocomplete]="auto"
                                [readonly] = "grpField.rolePermission==1">
                         <mat-autocomplete #auto="matAutocomplete">
                           <mat-option *ngFor="let option of cityOption" [value]="option">
                             {{option}}
                           </mat-option>
                         </mat-autocomplete>
                              </mat-form-field>
                            </div>

                            <div class="divide">
                              <mat-form-field>
                                <mat-select [disabled] = "grpField.rolePermission==1" [(ngModel)]="stateValue" formControlName="State" placeholder="State">
                                  <mat-option>None</mat-option>
                                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>

                            <div class="divide">
                              <mat-form-field>
                                <input type="text"
                            placeholder="Zip Code"
                            aria-label="Number"
                            [(ngModel)]="zipValue"
                            matInput
                            (input)="searchZip($event.target.value)"
                            formControlName="ZipCode"
                            [matAutocomplete]="ZipCode"
                            [readonly] = "grpField.rolePermission==1">
                     <mat-autocomplete #ZipCode="matAutocomplete">
                       <mat-option *ngFor="let option of zipOption" [value]="option">
                         {{option}}
                       </mat-option>
                     </mat-autocomplete>
                              </mat-form-field>
                            </div>

           
                  </div>
                    
                          
                        </div>
                        <span
                            class="addmore"
                            (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0"
                          >
                            Add more</span
                          >
                      </div>
    
                      <div class="multipleBlock" *ngIf="grpField.fieldName == 'Email'">
                        <div
                          class="multype"
                          *ngFor="let element of dynamicArray; let i = index"
                        >
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select
                              (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{
                                element.fieldName + 'option'
                              }}"
                              placeholder="{{ element.placeholderVal }}"
                            >
                              <mat-option
                                value="{{ names.fieldNameID }}"
                                *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                "
                                >{{ names.fieldName }}</mat-option
                              >
                            </mat-select>
                          </mat-form-field>

                          <mat-form-field>
                            <input
                            matInput
                            placeholder="Add Email"
                           [(ngModel)]="element.fieldValue"
                            formControlName="{{ element.fieldName}}"
                            [readonly] = "grpField.rolePermission==1"
                            pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                          />
                          </mat-form-field>
                          
                          
                        </div>
                        <span
                            class="addmore"
                            (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0"
                          >
                            Add more</span
                          >
                      </div>
    
                      <div class="multipleBlock" *ngIf="grpField.fieldName == 'Phone'">
                        <div
                          class="multype"
                          *ngFor="let element of dynamicArrayPhone; let i = index"
                        >
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select
                              (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{
                                element.fieldName  + 'option'
                              }}"
                              placeholder="{{ grpField.fieldNames[0].fieldName }}"
                            >
                              <mat-option
                                value="{{ names.fieldNameID }}"
                                *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                "
                                >{{ names.fieldName }}</mat-option
                              >
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field>
                            <input
                            
                            matInput
                          
                            [(ngModel)]="element.fieldValue"
                            placeholder="Add Phone"
                            formControlName="{{ element.fieldName }}"
                            [readonly] = "grpField.rolePermission==1"
                          />
                          </mat-form-field>
                          
                          
                        </div>
                        <span
                            class="addmore"
                            (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0"
                          >
                            Add more</span
                          >
                      </div>
    
                      <div
                        class="multipleBlock"
                        *ngIf="grpField.fieldName == 'Address'"
                      >
                        <div
                          class="multype"
                          *ngFor="let element of dynamicArrayAddress; let i = index"
                        >
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select
                             [ngModel]="element.fieldNameID"
                              (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{
                                element.fieldName + 'option'
                              }}"
                              placeholder="{{ element.placeholderVal }}"
                            >
                              <mat-option
                                value="{{ names.fieldNameID }}"
                                *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                "
                                >{{ names.fieldName }}</mat-option
                              >
                            </mat-select>
                          </mat-form-field>
                          
                          <mat-form-field>
                            <input
                            matInput
                            placeholder="Add Address"
                            [(ngModel)]="element.fieldValue"
                            formControlName="{{ element.fieldName }}"
                            [readonly] = "grpField.rolePermission==1"
                          />
                          </mat-form-field>
                          
                          <div *ngIf="element.address.length>0"  class="inOline">
                            <ng-container  *ngFor=" let adr of element.address;" >
                            

                            <!-- <div class="divide">
                              <mat-form-field> -->
                                <input *ngIf="adr.childFieldType==3"
                          placeholder="City"
                          aria-label="Number"
                          matInput
                          [ngModel]="adr.fieldValue"
                          (input)="searchCity($event.target.value)"
                          formControlName="City{{(i + 1) }}"
                          [matAutocomplete]="auto"
                          [readonly] = "grpField.rolePermission==1">
                   <mat-autocomplete #auto="matAutocomplete">
                     <mat-option *ngFor="let option of cityOption" [value]="option">
                       {{option}}
                     </mat-option>
                   </mat-autocomplete>
                              <!-- </mat-form-field>
                            </div> -->

                            <!-- <div class="divide">
                              <mat-form-field> -->
                                <mat-select [disabled] = "grpField.rolePermission==1" [ngModel]="adr.fieldValue" *ngIf="adr.childFieldType==2"  formControlName="State{{ (i + 1) }}"
                                 placeholder="State">
                                  <mat-option>None</mat-option>
                                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                </mat-select>
                              <!-- </mat-form-field>
                            </div> -->
                              
                           
                            <!-- <div class="divide">
                              <mat-form-field> -->
                                <input  *ngIf="adr.childFieldType==4"
                      placeholder="Zip Code"
                      [ngModel]="adr.fieldValue"
                      aria-label="Number"
                      matInput
                      (input)="searchZip($event.target.value)"
                      formControlName="ZipCode{{ (i + 1) }}"
                      [matAutocomplete]="ZipCode"
                      [readonly] = "grpField.rolePermission==1">
               <mat-autocomplete #ZipCode="matAutocomplete">
                 <mat-option *ngFor="let option of zipOption" [value]="option">
                   {{option}}
                 </mat-option>
               </mat-autocomplete>
                              <!-- </mat-form-field>
                            </div> -->
                       
                  
                    </ng-container>
                      </div>
                        <div *ngIf="element.address.length==0" class="inOline">

                          <div class="divide">
                            <mat-form-field>
                              <input 
                              placeholder="City"
                              aria-label="Number"
                              matInput
                              (input)="searchCity($event.target.value)"
                              formControlName="City{{(i + 1) }}"
                              [matAutocomplete]="auto"
                              [readonly] = "grpField.rolePermission==1">
                       <mat-autocomplete #auto="matAutocomplete">
                         <mat-option *ngFor="let option of cityOption" [value]="option">
                           {{option}}
                         </mat-option>
                       </mat-autocomplete>
                            </mat-form-field>
                          </div>

                          <div class="divide">
                            <mat-form-field>
                              <mat-select [disabled] = "grpField.rolePermission==1"  formControlName="State{{ (i + 1) }}"
                               placeholder="State">
                                <mat-option>None</mat-option>
                                <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="divide">
                            <mat-form-field>
                              <input 
                      placeholder="Zip Code"
                      aria-label="Number"
                     matInput
                      (input)="searchZip($event.target.value)"
                      formControlName="ZipCode{{ (i + 1) }}"
                      [matAutocomplete]="ZipCode"
                      [readonly] = "grpField.rolePermission==1">
               <mat-autocomplete #ZipCode="matAutocomplete">
                 <mat-option *ngFor="let option of zipOption" [value]="option">
                   {{option}}
                 </mat-option>
               </mat-autocomplete>
                            </mat-form-field>
                          </div>


                          
                    
                        </div>
                          
                        </div>
                        <span
                            class="addmore"
                            (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0"
                          >
                            Add more</span
                          >
                      </div>
    
                      <div
                        class="multipleBlock"
                        *ngIf="grpField.fieldName == 'WebSite'"
                      >
                        <div
                          class="multype"
                          *ngFor="let element of dynamicArrayWebsite; let i = index"
                        >
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select
                              (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{
                                element.fieldName + 'option'
                              }}"
                            >
                              <mat-option
                                value="{{ names.fieldNameID }}"
                                *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                "
                                >{{ names.fieldName }}</mat-option
                              >
                            </mat-select>
                          </mat-form-field>


                          <mat-form-field>
                            <input
                            matInput
                            placeholder="WebSite"
                            [(ngModel)]="element.fieldValue"
                            formControlName="{{ element.fieldName }}"
                            [readonly] = "grpField.rolePermission==1"
                          />
                          </mat-form-field>
                          
                          
                        </div>
                        <span
                            class="addmore"
                            (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0"
                          >
                            Add more</span
                          >
                      </div>
                    </ng-container>
    
                    <mat-form-field *ngIf="grpField.fieldNames.length === 0">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <input matInput [required]="grpField.isRequired" placeholder="Add {{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                    [readonly] = "grpField.rolePermission==1"/>
                    </mat-form-field>
                  </ng-container>
                </ng-container>
    
                <ng-container *ngSwitchCase="'Textarea'">
                  <mat-form-field>
                    <textarea
                      [required]="grpField.isRequired"
                      matInput
                      placeholder="{{ grpField.fieldName }}"
                      formControlName="{{ grpField.fieldName }}"
                      [readonly] = "grpField.rolePermission==1"
                    ></textarea>
                  </mat-form-field>
                </ng-container>
    
                <ng-container *ngSwitchCase="'Number'">
                  <mat-form-field>
                    <input
                    [required]="grpField.isRequired"
                      matInput
                      (keypress)="numberOnly($event)"
                      placeholder="{{ grpField.fieldName }}"
                      formControlName="{{ grpField.fieldName }}"
                      [readonly] = "grpField.rolePermission==1"/>
                  </mat-form-field>
                </ng-container>
    
                <ng-container *ngSwitchCase="'Currency'">
                  <mat-form-field>
                    <input
                    [required]="grpField.isRequired"
                      matInput                   
                      placeholder="{{ grpField.fieldName }}"
                      formControlName="{{ grpField.fieldName }}"
                      [readonly] = "grpField.rolePermission==1"/>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'Address'">
                  <mat-form-field>
                    <input
                    [required]="grpField.isRequired"
                      matInput                   
                      placeholder="{{ grpField.fieldName }}"
                      formControlName="{{ grpField.fieldName }}"
                      [readonly] = "grpField.rolePermission==1"/>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'Image'">
                  <!-- <mat-form-field> -->
                  <mat-label>{{ grpField.fieldName }}</mat-label>
                  <div class="pic">
                    <input
                      type="file"
                      placeholder="{{ grpField.fieldName }}"
                      formControlName="{{ grpField.fieldName }}"
                      (change)="onSelectFile($event)"
                      [readonly] = "grpField.rolePermission==1"
                    />
                    <!-- <img src="../../../../../../assets/images/avatars/Abbott.jpg" alt="" >  -->
                    <span class="ico">
                      <mat-icon>add_a_photo</mat-icon>
                    </span>
                  </div>
                  <!-- </mat-form-field> -->
                </ng-container>
    
                <ng-container *ngSwitchCase="'Date'">
                  <mat-form-field>
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <input
                      [required]="grpField.isRequired"
                      matInput
                      [matDatepicker]="basicDatepicker"
                      placeholder="{{ grpField.fieldName }}"
                      formControlName="{{ grpField.fieldName }}"
                      [readonly] = "grpField.rolePermission==1"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="basicDatepicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #basicDatepicker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
    
                <ng-container *ngSwitchCase="'URL'">
                  <mat-form-field>
                    <input [required]="grpField.isRequired"
                      matInput
                      placeholder="{{ grpField.fieldName }}"
                      formControlName="{{ grpField.fieldName }}"
                      [readonly] = "grpField.rolePermission==1"
                    />
                  </mat-form-field>
                </ng-container>
    
                <ng-container *ngSwitchCase="'Dropdown'" >
                   <mat-form-field *ngIf="grpField.fieldName == 'Type'">
                        <mat-label>{{ grpField.fieldName }}</mat-label>
                        <mat-select [required]='grpField.isRequired' [(ngModel)]="TypeIdDrp"
                          formControlName="{{ grpField.fieldName }}"
                          (selectionChange)="getCoreUserDetailsOnTypeChange($event,grpField.fieldName)">
                          <mat-option *ngFor="let typelist of TypeListForDropDown" [value]="typelist.subFolderID">
                            {{typelist.folderName}}
                          </mat-option>
                        </mat-select>

                        </mat-form-field>

                  <mat-form-field *ngIf="grpField.fieldName != 'Type'">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-select [disabled] = "grpField.rolePermission==1" [required]="grpField.isRequired"
                    [ngModel]="getddlSelectedVal(grpField.fieldName)"  formControlName="{{ grpField.fieldName }}">
                      <mat-option
                        *ngFor="let drp of getdropdownlist(grpField.fieldName)"
                        [value]="drp"
                      >
                        {{ drp }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
    
                <ng-container *ngSwitchCase="'MultiSelect'">
                  <mat-form-field class="example-chip-list" *ngIf="grpField.fieldName == 'Tags'">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-chip-list [required]='grpField.isRequired' #chipList aria-label="Tag selection">
                      <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                        (removed)="remove(tag)">
                        {{tag}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                      <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                      <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                        {{tag}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
    
                  <mat-form-field *ngIf="grpField.fieldName != 'Tags'">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <!-- [ngModel]="getMultiddlSelectedVal(grpField.fieldName)" -->
                    <mat-select [disabled] = "grpField.rolePermission==1" [required]='grpField.isRequired' multiple 
                      formControlName="{{ grpField.fieldName }}">
                      <mat-option *ngFor="
                          let muldrp of getMuldropdownlist(grpField.fieldName)
                        " [value]="muldrp">
                        {{ muldrp }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  
                </ng-container>
                
                <!-- <ng-container *ngSwitchCase="'MultiSelect' && grpField.fieldName!='Tags'">
                  <mat-form-field>
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-select [disabled] = "grpField.rolePermission==1" [required]="grpField.isRequired" multiple formControlName="{{ grpField.fieldName }}">
                      <mat-option
                        *ngFor="let muldrp of getMuldropdownlist(grpField.fieldName)"
                        [value]="muldrp"
                      >
                        {{ muldrp }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container> -->
    
                <!-- <ng-container *ngSwitchCase="'MultiSelect' || grpField.fieldName ==='Tags'">
                  <mat-form-field class="example-chip-list">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-chip-list [required]="grpField.isRequired" #chipList aria-label="Fruit selection">
                      <mat-chip
                        *ngFor="let fruit of filteredFruits"
                        [selectable]="selectable"
                        [removable]="removable"
                        (removed)="remove(fruit)">
                        {{fruit}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                      <input
                        placeholder="Add Tags"
                        #fruitInput
                        [formControl]="fruitCtrl"
                        [matAutocomplete]="auto"
                        [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)"
                        [readonly] = "grpField.rolePermission==1">
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                      <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                        {{fruit}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </ng-container> -->
    
               
    
                <ng-container *ngSwitchCase="'Checkbox'">
                  <!-- <mat-form-field> -->
                  <mat-label>{{ grpField.fieldName }}</mat-label>
                  <ul class="check">
                    <li *ngFor="let chk of getCheckBoxlist(grpField.fieldName)">
                      <mat-checkbox
                        color="primary"
                        [disabled] = "grpField.rolePermission==1"
                        (change)="OnChange($event, chk, grpField.fieldID)"
                      >
                        {{ chk }}
                      </mat-checkbox>
                    </li>
                  </ul>
                  <!-- </mat-form-field> -->
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
        <div [ngSwitch]="field.fieldTypeName" class="fullw" *ngIf="field.fieldID>0" [class.fullw--wide]="isWideField(field)">
          <div *ngSwitchCase="'Textbox'">
            <!-- <mat-form-field>   
                    <mat-label>{{field.fieldName}}</mat-label>
                      <input matInput  [(ngModel)]="field.fieldValue"  placeholder="{{field.fieldName}}"  formControlName="{{field.fieldName}}">
                    </mat-form-field> -->

            <ng-container *ngIf="field.fieldNames.length > 0">
              <ng-container>
                <div class="multipleBlock">
                  <div class="multype">
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select
                        [ngModel]="field.fieldNameID"
                        formControlName="{{ field.fieldName + 'option' }}"
                      >
                        <mat-option
                          [value]="names.fieldNameID"
                          *ngFor="
                            let names of field.fieldNames;
                            trackby: fieldNameID
                          "
                          >{{ names.fieldName }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                      <input [required]='field.isRequired'
                      *ngIf="field.fieldName == 'Phone'"
                      matInput
                      placeholder="Add Phone"
                      [(ngModel)]="field.fieldValue"
                      formControlName="{{ field.fieldName }}"
                     
                      [readonly] = "field.rolePermission==1"
                    />
                    <input [required]='field.isRequired'
                    *ngIf="field.fieldName == 'Email'"
                    matInput
                    placeholder="Add Email"
                    [(ngModel)]="field.fieldValue"
                    formControlName="{{ field.fieldName }}"                        
                    [readonly] = "field.rolePermission==1"
                    pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                  />
                  <input [required]='field.isRequired'
                    *ngIf="field.fieldName != 'Phone' && field.fieldName != 'Email' "
                    matInput
                    placeholder="Add {{field.placeholder}}"
                    [(ngModel)]="field.fieldValue"
                    formControlName="{{ field.fieldName }}"
                    [readonly] = "field.rolePermission==1"
                  />
                    </mat-form-field>
                    
                    <!-- // -->
                    <div *ngIf="field.fieldName == 'Address'" class="inOline">

                      <div class="divide">
                        <mat-form-field>
                          <input type="text"
                          placeholder="City"
                          [(ngModel)]="cityValue"
                          aria-label="Number"
                          matInput
                          (input)="searchCity($event.target.value)"
                          formControlName="City"
                          [matAutocomplete]="auto"
                          [readonly] = "field.rolePermission==1">
                   <mat-autocomplete #auto="matAutocomplete">
                     <mat-option *ngFor="let option of cityOption" [value]="option">
                       {{option}}
                     </mat-option>
                   </mat-autocomplete>
                        </mat-form-field>
                      </div>

                      <div class="divide">
                        <mat-form-field>
                          
             <mat-select  [disabled] = "field.rolePermission==1"  [(ngModel)]="stateValue"  formControlName="State"  placeholder="State">
              <mat-option>None</mat-option>
              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
            </mat-select>
                        </mat-form-field>
                      </div>

                      <div class="divide">
                        <mat-form-field>
                          <input type="text"
                                 [(ngModel)]="zipValue"
                      placeholder="Zip Code"
                      aria-label="Number"
                      matInput
                      (input)="searchZip($event.target.value)"
                      formControlName="ZipCode"
                      [matAutocomplete]="ZipCode"
                      [readonly] = "field.rolePermission==1">
               <mat-autocomplete #ZipCode="matAutocomplete">
                 <mat-option *ngFor="let option of zipOption" [value]="option">
                   {{option}}
                 </mat-option>
               </mat-autocomplete>
                        </mat-form-field>
                      </div>

                      
           
                                 
          </div>
            <!-- <input *ngIf="field.fieldName == 'Address'"
                    class="addinput"
                    placeholder="Add Country"
                    [(ngModel)]="countryValue"
                    formControlName="Country"
                  /> -->
                    <!-- // -->
                    
                  </div>
                  <span
                      class="addmore"
                      (click)="addMore(field.fieldName)"
                      *ngIf="field.fieldNames.length > 0"
                    >
                      Add more
                    </span>
                </div>
                <div class="multipleBlock" *ngIf="field.fieldName == 'Email'">
                  <div
                    class="multype"
                    *ngFor="let element of dynamicArray; let i = index"
                  >
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select
                        [ngModel]="element.fieldNameID"
                        (selectionChange)="clearPlaceholder($event)"
                        formControlName="{{ element.fieldName + 'option' }}"
                        placeholder="{{ element.placeholderVal }}"
                      >
                        <mat-option
                          value="{{ names.fieldNameID }}"
                          *ngFor="
                            let names of element.fieldNames;
                            trackby: fieldNameID
                          "
                          >{{ names.fieldName }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                      matInput
                      placeholder="Add Email"
                      [(ngModel)]="element.fieldValue"
                      formControlName="{{ element.fieldName }}"
                      [readonly] = "field.rolePermission==1"
                      pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                    />
                    </mat-form-field>
                    
                    
                  </div>
                  <span
                      class="addmore"
                      (click)="addMore(field.fieldName)"
                      *ngIf="field.fieldNames.length > 0"
                    >
                      Add more
                    </span>
                </div>

                <div class="multipleBlock" *ngIf="field.fieldName == 'Phone'">
                  <div
                    class="multype"
                    *ngFor="let element of dynamicArrayPhone; let i = index"
                  >
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select
                        [ngModel]="element.fieldNameID"
                        (selectionChange)="clearPlaceholder($event)"
                        formControlName="{{ element.fieldName + 'option' }}"
                        placeholder="{{ element.placeholderVal }}"
                      >
                        <mat-option
                          value="{{ names.fieldNameID }}"
                          *ngFor="
                            let names of element.fieldNames;
                            trackby: fieldNameID
                          "
                          >{{ names.fieldName }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                      <input
                      matInput
                      
                      placeholder="Add Phone"
                      [(ngModel)]="element.fieldValue"
                      formControlName="{{ element.fieldName }}"                     
                      [readonly] = "field.rolePermission==1"
                    />
                    </mat-form-field>

                    
                    
                  </div>
                  <span
                      class="addmore"
                      (click)="addMore(field.fieldName)"
                      *ngIf="field.fieldNames.length > 0"
                    >
                      Add more
                    </span>
                </div>

                <div class="multipleBlock" *ngIf="field.fieldName == 'Address'"
                >
                  <div
                    class="multype"
                    *ngFor="let element of dynamicArrayAddress; let i = index"
                  >
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select
                        [ngModel]="element.fieldNameID"
                        (selectionChange)="clearPlaceholder($event)"
                        formControlName="{{ element.fieldName + 'option' }}"
                        placeholder="{{ element.placeholderVal }}"
                      >
                        <mat-option
                          value="{{ names.fieldNameID }}"
                          *ngFor="
                            let names of element.fieldNames;
                            trackby: fieldNameID
                          "
                          >{{ names.fieldName }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                      <input
                      matInput
                      placeholder="Add Address"
                      [(ngModel)]="element.fieldValue"
                      formControlName="{{ element.fieldName }}"
                      [readonly] = "field.rolePermission==1"
                    />
                    </mat-form-field>
                    
                    <div *ngIf="element.address.length>0" class="inOline">
                      <ng-container  *ngFor=" let adr of element.address;"  >


                        <!-- <div class="divide">
                          <mat-form-field> -->
                            <input *ngIf="adr.childFieldType==3"
                            placeholder="City"
                            [ngModel]="adr.fieldValue"
                                  aria-label="Number"
                                  matInput
                                  (input)="searchCity($event.target.value)"
                                  formControlName="City{{(i + 1) }}"
                                  [matAutocomplete]="auto"
                                  [readonly] = "field.rolePermission==1">
                           <mat-autocomplete #auto="matAutocomplete">
                             <mat-option *ngFor="let option of cityOption" [value]="option">
                               {{option}}
                             </mat-option>
                           </mat-autocomplete>
                          <!-- </mat-form-field>
                        </div> -->

                        <!-- <div class="divide">
                          <mat-form-field> -->
                            <mat-select [disabled] = "field.rolePermission==1" [ngModel]="adr.fieldValue" *ngIf="adr.childFieldType==2" 
                            formControlName="State{{ (i + 1) }}"  placeholder="State">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                            </mat-select>
                          <!-- </mat-form-field>
                        </div> -->

                        <!-- <div class="divide">
                          <mat-form-field> -->
                            <input  *ngIf="adr.childFieldType==4"
                placeholder="Zip Code"
                [ngModel]="adr.fieldValue"
                aria-label="Number"
                matInput
                (input)="searchZip($event.target.value)"
                formControlName="ZipCode{{ (i + 1) }}"
                [matAutocomplete]="ZipCode"
                [readonly] = "field.rolePermission==1">
         <mat-autocomplete #ZipCode="matAutocomplete">
           <mat-option *ngFor="let option of zipOption" [value]="option">
             {{option}}
           </mat-option>
         </mat-autocomplete>
                          <!-- </mat-form-field>
                        </div> -->

      
              </ng-container>
                 
                </div>
                  <div *ngIf="element.address.length==0" class="inOline">

                    

                    <div class="divide">
                      <mat-form-field>
                        <input 
                    placeholder="City"
                    aria-label="Number"
                    matInput
                    (input)="searchCity($event.target.value)"
                    formControlName="City{{(i + 1) }}"
                    [matAutocomplete]="auto"
                    [readonly] = "field.rolePermission==1">
             <mat-autocomplete #auto="matAutocomplete">
               <mat-option *ngFor="let option of cityOption" [value]="option">
                 {{option}}
               </mat-option>
             </mat-autocomplete>
                      </mat-form-field>
                    </div>


                    <div class="divide">
                      <mat-form-field>
                        <mat-select [disabled] = "field.rolePermission==1"  formControlName="State{{ (i + 1) }}"  placeholder="State">
                          <mat-option>None</mat-option>
                          <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>


                    <div class="divide">
                      <mat-form-field>
                        <input 
                placeholder="Zip Code"
                aria-label="Number"
                matInput
                (input)="searchZip($event.target.value)"
                formControlName="ZipCode{{ (i + 1) }}"
                [matAutocomplete]="ZipCode"
                [readonly] = "field.rolePermission==1">
         <mat-autocomplete #ZipCode="matAutocomplete">
           <mat-option *ngFor="let option of zipOption" [value]="option">
             {{option}}
           </mat-option>
         </mat-autocomplete>
                      </mat-form-field>
                    </div>

                    
                 
                
                  </div>
                 
                    
                  </div>
                  <span
                      class="addmore"
                      (click)="addMore(field.fieldName)"
                      *ngIf="field.fieldNames.length > 0"
                    >
                      Add more
                    </span>
                </div>

                <div
                  class="multipleBlock"
                  *ngIf="field.fieldName == 'WebSite'"
                >
                  <div
                    class="multype"
                    *ngFor="let element of dynamicArrayWebsite; let i = index"
                  >
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select
                        [ngModel]="element.fieldNameID"
                        (selectionChange)="clearPlaceholder($event)"
                        formControlName="{{
                          element.fieldName + 'option'
                        }}"
                        placeholder="{{ element.placeholderVal }}"
                      >
                        <mat-option
                          value="{{ names.fieldNameID }}"
                          *ngFor="
                            let names of element.fieldNames;
                            trackby: fieldNameID
                          "
                          >{{ names.fieldName }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                      <input
                      matInput
                      placeholder="WebSite"
                      [(ngModel)]="element.fieldValue"
                      formControlName="{{ element.fieldName + (i + 1) }}"
                      [readonly] = "field.rolePermission==1"
                    />
                    </mat-form-field>

                   
                    
                  </div>
                  <span
                      class="addmore"
                      (click)="addMore(field.fieldName)"
                      *ngIf="field.fieldNames.length > 0"
                    >
                      Add more
                    </span>
                </div>
              </ng-container>
            </ng-container>
            <mat-form-field *ngIf="field.fieldName == 'Name'">
              <input
                matInput
                [required]="field.isRequired"
                [(ngModel)]="transactionUserName"
                placeholder="{{ field.fieldName }}"
                formControlName="{{ field.fieldName }}"
                [readonly] = "field.rolePermission==1"
              />
              <mat-error
                *ngIf="
                  myFormGroup.get(field.fieldName).invalid &&
                  (myFormGroup.get(field.fieldName).dirty ||
                    myFormGroup.get(field.fieldName).touched)
                "
              >
                <span *ngIf="myFormGroup.get(field.fieldName).errors.required"
                  >This field is mandatory.</span
                >
              </mat-error>
            </mat-form-field>
            <mat-form-field
              *ngIf="
                field.fieldNames.length === 0 && field.fieldName != 'Name'
              "
            >

            <mat-label>{{ field.fieldName }}</mat-label>
              <input [required]='field.isRequired'
                matInput
                [(ngModel)]="field.fieldValue"
                placeholder="{{ field.fieldName }}"
                formControlName="{{ field.fieldName }}"
                [readonly] = "field.rolePermission==1"
              />
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'Textarea'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <textarea [required]='field.isRequired'
                matInput
                [(ngModel)]="field.fieldValue"
                placeholder="{{ field.fieldName }}"
                formControlName="{{ field.fieldName }}"
                [readonly] = "field.rolePermission==1"
              ></textarea>
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'Number'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input [required]='field.isRequired'
                matInput
                (keypress)="numberOnly($event)"
                placeholder="{{ field.fieldName }}"
                [(ngModel)]="field.fieldValue"
                formControlName="{{ field.fieldName }}"
                [readonly] = "field.rolePermission==1"/>
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'Currency'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input [required]='field.isRequired'
                matInput              
                placeholder="{{ field.fieldName }}"
                [(ngModel)]="field.fieldValue"
                formControlName="{{ field.fieldName }}"
                [readonly] = "field.rolePermission==1"/>
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'Address'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input [required]='field.isRequired'
                matInput              
                placeholder="{{ field.fieldName }}"
                [(ngModel)]="field.fieldValue"
                formControlName="{{ field.fieldName }}"
                [readonly] = "field.rolePermission==1"/>
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'URL'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input [required]='field.isRequired'
                matInput
                [(ngModel)]="field.fieldValue"
                placeholder="{{ field.fieldName }}"
                formControlName="{{ field.fieldName }}"
                [readonly] = "field.rolePermission==1"
              />
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'Date'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input [required]='field.isRequired'
                matInput
                [matDatepicker]="basicDatepicker"
                [(ngModel)]="field.fieldValue"
                formControlName="{{ field.fieldName }}"
                [readonly] = "field.rolePermission==1"
              />
              <mat-icon *ngIf="field.fieldValue" matDatepickerToggleIcon class="mat-icon-Cleardate" (click)="clearDate(field)">clear</mat-icon>
              <mat-datepicker-toggle
                matSuffix
                [for]="basicDatepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #basicDatepicker></mat-datepicker>
            </mat-form-field>
          </div>

        

         <ng-container *ngSwitchCase="'Dropdown'">
                  <mat-form-field *ngIf="field.fieldName == 'Type'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <mat-select [required]='field.isRequired' [(ngModel)]="TypeIdDrp"
                      formControlName="{{ field.fieldName }}"
                      (selectionChange)="getCoreUserDetailsOnTypeChange($event,field.fieldName)">
                      <mat-option *ngFor="let typelist of TypeListForDropDown" [value]="typelist.subFolderID">
                        {{typelist.folderName}}
                      </mat-option>
                    </mat-select>

                  </mat-form-field>

                 <mat-form-field *ngIf="field.fieldName.toLowerCase() == 'pdpm category'">
                   <mat-label>{{ field.fieldName }}</mat-label>
                    <mat-select [required]='field.isRequired' [(ngModel)]="medicalCategoryID" formControlName="{{ field.fieldName }}" (selectionChange)="selectStage($event.value)">
                    <mat-option *ngFor="let stat of getPDPMStagesList" [value]="stat.processStageID">
                    {{ stat.processStageName }}
                    </mat-option>
                   </mat-select>
                  </mat-form-field>

                  <mat-form-field *ngIf="field.fieldName == 'Process Stage'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <mat-select [required]='field.isRequired' [(ngModel)]="ProcessStageIdDrp"
                      formControlName="{{ field.fieldName }}"
                      (selectionChange)="selectProcessStageOnChange($event,field.fieldName)">
                      <mat-option *ngFor="let typelist of ProcessStageListForDropDown"
                        [value]="typelist.processStageID">
                        {{typelist.processStageName}}
                      </mat-option>
                    </mat-select>

                  </mat-form-field>
                 
                 <mat-form-field *ngIf="field.fieldName != 'Type' && field.fieldName != 'Process Stage' && field.fieldName.toLowerCase() != 'pdpm category'">
                  <mat-label>{{ field.fieldName }}</mat-label>
                  <mat-select [disabled]="field.rolePermission==1" [required]='field.isRequired'
                    [ngModel]="getddlSelectedVal(field.fieldName)" formControlName="{{ field.fieldName }}">
                    <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                      {{ drp }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

               
                </ng-container>

          
          <ng-container *ngSwitchCase="'MultiSelect'">
            <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-chip-list [required]='field.isRequired' #chipList aria-label="Tag selection">
                <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                  (removed)="remove(tag)">
                  {{tag}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event)">
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                  {{tag}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field *ngIf="field.fieldName != 'Tags'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <!-- [ngModel]="getMultiddlSelectedVal(field.fieldName)" -->
              <mat-select [disabled] = "field.rolePermission==1" [required]='field.isRequired' multiple 
                formControlName="{{ field.fieldName }}">
                <mat-option *ngFor="
                    let muldrp of getMuldropdownlist(field.fieldName)
                  " [value]="muldrp">
                  {{ muldrp }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

         
          <ng-container *ngSwitchCase="'Checkbox'">
            <div class="checkList">
              <mat-label>{{ field.fieldName }}</mat-label>

              <div
                class="allCheckList"
                *ngFor="let chk of getCheckBoxlist(field.fieldName)"
                
              >
                <mat-checkbox
                  color="primary"
                  [disabled] = "field.rolePermission==1"
                  [checked]="isChecked(field.fieldName, chk)"
                  (change)="OnChange($event, chk, field.fieldID)"
                >
                  {{ chk }}
                </mat-checkbox>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

     
    </form>
   </div>
    </mat-tab>
      
     <mat-tab label="Notes">
        <div class="touches_holder">
         
          <div class="addtouch">
            <button mat-stroked-button color="primary" (click)="addTouch()" ><mat-icon>add</mat-icon> Add Note</button>
          </div>

          <div class="touches" *ngFor="let touch of AllCoreTouchesList">
            
            <app-touches-list [touch]="touch"  
            (editTouchEmmitter)="editTouch($event)"
            (deleteTouchEmmitter)="deleteTouch($event)"        
            ></app-touches-list>

          </div>

         
        </div>
     </mat-tab>

   </mat-tab-group>

  </div>

  <div class="dd-footer" *ngIf="textLabel!='Note'">
    <button mat-stroked-button type="button" (click)="closeListingDetails()" class="cancel">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" (click)="SaveCoreUserDetails(myFormGroup.value)">
      Save changes
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20"></mat-spinner></mat-icon>
    </button>
  </div>

</mat-card>


<div class="overlay" (click)="closeListingDetails()"></div>
